import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ConsultedUsers = ({ setSelectedPage }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = "https://admindashboard.clns.in/api/dashboard/consulted_lawyers/";

  const fetchData = () => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(API_URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setTableData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  };

  useEffect(() => {
    // Fetch data from the API when the component mounts
    fetchData();
  }, []);

  const handleAddCase = (clientId, advocateId, name) => {
    if (clientId && advocateId) {
      localStorage.setItem("advocateId", advocateId);
      localStorage.setItem("clientId", clientId);
      setSelectedPage("AddCaseDetails");

      console.log(name, "name");
      // Only call setCheck if it's provided as a prop
      localStorage.setItem("data", JSON.stringify(name));
    }
  };

  const handleAccept = (interactionId, hiredStatus) => {
    // Only update if the current status is 4
    if (hiredStatus === 4) {
      setLoading(true);
      const token = localStorage.getItem("token");
      
      const payload = {
        interaction_id: interactionId,
        status: 5
      };
      
      axios
        .put(API_URL, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log("Status updated successfully:", response.data);
          // Refresh the data after successful update
          fetchData();
        })
        .catch((error) => {
          console.error("Error updating status:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      console.log("Cannot accept: hired status is not 4");
    }
  };

  return (
    <div style={styles.page}>
      <h3 style={styles.title}>
        Consulted Users Who Clicked Talk, Consulted Again, Hire Lawyer Button
      </h3>

      <div style={styles.gridContainer}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.header}>Client Name</th>
                <th style={styles.header}>Lawyer Name</th>
                <th style={styles.header}>C Location</th>
                <th style={styles.header}>L Location</th>
                <th style={styles.header}>C Phoneno.</th>
                <th style={styles.header}>L Phoneno.</th>
                <th style={styles.header}>Status</th>
                <th style={styles.header}>Date</th>
                <th style={styles.header}>Add Case</th>
                <th style={styles.header}>Accept</th>
                <th style={styles.header}>No Use</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row, index) => {
                const clientId = row?.clients?.client_id;
                const advocateId = row?.advocate?.advocate_id;
                const interactionId = row?.id;
                const hiredStatus = row?.hired_status;

                if (!clientId || !advocateId) return null;

                return (
                  <tr key={index} style={styles.row}>
                    <td style={styles.cell}>
                      {row?.clients?.first_name + " " + row?.clients?.last_name}
                    </td>
                    <td style={styles.cell}>
                      {row?.advocate?.first_name +
                        " " +
                        row?.advocate?.last_name}
                    </td>
                    <td style={styles.cell}>{row?.clients.location}</td>
                    <td style={styles.cell}>{row?.advocate.city}</td>
                    <td style={styles.cell}>
                      {row?.clients?.client_mobile_num}
                    </td>
                    <td style={styles.cell}>{row?.advocate?.mobile_num}</td>
                    <td style={styles.cell}>{row?.consulted_status}</td>
                    <td style={styles.cell}>{row?.interaction_date}</td>
                    <td style={styles.buttonCell}>
                      <button
                        style={styles.addButton}
                        onClick={() =>
                          handleAddCase(clientId, advocateId, {
                            advocateName:
                              row?.advocate?.first_name +
                              " " +
                              row?.advocate?.last_name,
                            advocateNumber: row?.advocate?.mobile_num,
                            advocateLocation: row?.advocate.city,
                            clientName:
                              row?.clients?.first_name +
                              " " +
                              row?.clients?.last_name,
                            clientNumber: row?.clients?.client_mobile_num,
                            clientLocation: row?.clients.location,
                          })
                        }
                      >
                        Add Case
                      </button>
                    </td>
                    <td style={styles.buttonCell}>
                      <button 
                        style={{
                          ...styles.addButton,
                          backgroundColor: hiredStatus === 4 ? '#007bff' : '#cccccc',
                          cursor: hiredStatus === 4 ? 'pointer' : 'not-allowed',
                        }}
                        onClick={() => handleAccept(interactionId, hiredStatus)}
                        disabled={hiredStatus !== 4 || loading}
                      >
                        {loading ? 'Processing...' : 'Accept'}
                      </button>
                    </td>
                    <td style={styles.buttonCell}>
                      <button style={styles.noUseButton}>No use</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: "grid",
    gap: "20px",
    paddingLeft: "10%",
    height: "50vh",
    backgroundColor: "#f9f9f9",
  },
  title: {
    paddingRight: "20%",
    margin: "10px 10px",
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "center",
  },
  gridContainer: {
    display: "grid",
    gap: "20px",
    overflow: "hidden",
  },
  tableContainer: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "white",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    minWidth: "1200px",
  },
  header: {
    backgroundColor: "#f4f4f4",
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  cell: {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  buttonCell: {
    padding: "5px",
    textAlign: "center",
    border: "1px solid #ddd",
  },
  addButton: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  noUseButton: {
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  row: {
    backgroundColor: "#fff",
  },
};

export default ConsultedUsers;